module.exports = __webpack_public_path__ + "static/media/post_modal.fb4646ab.png";